import { Group } from '@mantine/core';
import React from 'react';

import styles from './TaskActions.module.css';

interface Props {
  children: React.ReactNode;
  dataId?: string;
}

export const TaskActions: React.FC<Props> = ({ children, dataId = 'taskActions' }) => {
  return (
    <div className={styles.root} data-id={dataId}>
      <div className={styles.actions}>
        <Group grow gap={8} wrap="nowrap">
          {children}
        </Group>
      </div>
    </div>
  );
};
